// models
import {
  names as applicationName,
  titles as applicationTitle,
  icons as applicationIcon,
  apps as applications
} from "@/model/solution/apps";

// design
import { iconApplication } from "@/design/icon/iconConst";

// services

// utilities
import {
  getLocalStorageItem,
  setLocalStorageItem
} from "@/utils/localStorageUtility";

/**
 * Get solution Name
 * @type {string}
 */
const solutionName = "CitySuite";

/**
 * Get Application
 * @param {String} appName
 * @returns {{title: String, icon: String, name: String}}
 */
const getApplication = appName => applications.find(el => el.name === appName);

/**
 * Get Application icon name
 * @param {String} appName
 * returns icon name
 * @returns {String}
 */
const getApplicationIcon = appName => {
  const app = getApplication(appName);
  return app ? app.icon : iconApplication;
};

/**
 * get Application Module Icon Name
 * @param appName
 * @param moduleName
 * @returns {string}
 */
const getApplicationModuleIcon = () => {
  return iconApplication;
};

/**
 * get Module
 * @param {String} appName
 * @param {String} moduleName
 * @returns {{title: String, icon: String, name: String, route: String, entity: String}}
 */
const getModule = () => {
  return undefined;
};

/**
 * Solution local Store Keys
 * @type {Readonly<{appName: string}>}
 */
const localStorageKey = Object.freeze({
  appName: "eapAppName"
});

/**
 * Get Stored Application Name from local Storage
 * @returns {string}
 */
const getStoredApplicationName = () =>
  getLocalStorageItem(localStorageKey.appName);
/**
 * Store Application Name to the local Storage
 * @param {String} appName
 */
const storeApplicationName = appName =>
  setLocalStorageItem(localStorageKey.appName, appName);

export {
  solutionName,
  applicationName,
  applicationIcon,
  applicationTitle,
  applications,
  getApplication,
  getApplicationIcon,
  getApplicationModuleIcon,
  getStoredApplicationName,
  storeApplicationName,
  getModule
};
